export const appendQueryParam = (key: string, value: string | number): void => {
    // 1. Start with current search params
    const searchParams = new URLSearchParams(window.location.search);

    // 2. Add or update your param
    searchParams.set(key, value.toString());

    // 3. Build the new URL correctly (no double encoding!)
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;

    // 4. Push new state
    window.history.pushState({}, "", newUrl);
};

export const clearQueryParams = () => {
    const newUrl = `${window.location.pathname}`;

    window.history.pushState({}, "", newUrl);
}